import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Header from '../Device/components/Header'
import { getFirstActiveTab } from '../redux/devices/services'
import { RTFDeviceData } from '../redux/devices/types'
import { RTFSettingsState } from '../redux/settings/types'
import { getTabFromLocation, mapSelectedTab } from '../redux/tab/services'
import Content from './components/Content'
import Sidebar from './components/Sidebar'

type SettingComponentProps = {
  currentDevice: RTFDeviceData
  settings: RTFSettingsState
  setTabReference: (selectedTab: string) => void
}

export default function SettingsComponent({ currentDevice, settings, setTabReference }: SettingComponentProps) {
  const { hardwareModel, softwareVersion, udid } = currentDevice
  const [tab, setTab] = useState(getFirstActiveTab(hardwareModel, softwareVersion))

  const location = useLocation()
  const { selectedTab } = getTabFromLocation(location.search)

  useEffect(() => {
    setTab(mapSelectedTab(selectedTab, hardwareModel, softwareVersion))
  }, [udid])

  useEffect(() => {
    setTabReference(tab)
  }, [tab])

  useEffect(() => {
    const { selectedTab } = getTabFromLocation(location.search)
    setTab(mapSelectedTab(selectedTab, hardwareModel, softwareVersion))
  }, [location])

  return (
    <>
      <Header {...currentDevice} />
      <div className="columns has-margin-top-md">
        <div className="column is-2"><Sidebar tab={tab} setTab={setTab} /></div>
        <div className="column is-10"><Content tab={tab} settings={settings.settings} /></div>
      </div>
    </>
  )
}
